<template>
    <div>
      <div class="card">
        <div class="card-header">
            <div class="col-md-12">
              <ol class="breadcrumb breadcrumb-card-header pull-left">
                  <li class="breadcrumb-item">
                    <a href="javascript:void(0);" @click="backParent">Purchasing</a>
                  </li>
                  <li class="breadcrumb-item">
                    <a href="javascript:void(0)" @click="backParent">[{{ purchasing.purchasing_no}}]</a>
                  </li>
                  <li class="breadcrumb-item active">
                    Payment
                  </li>
                  <!-- <li class="breadcrumb-item">
                    <router-link :to="{ name: 'purchasing', query: { purchasing: purchasing.id, form: 'true' }}">
                      <b>[{{ purchasing.purchasing_no }}]</b>
                    </router-link>
                  </li>
                  <li class="breadcrumb-item active">
                      <span v-if="inventory.id === null">New</span>
                      <span v-else>
                        {{ inventory.inventory_no }}
                      </span>
                  </li> -->
              </ol>
            </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <table class="table table-sm table-item table-striped">
                <thead>
                  <th>Date</th>
                  <th>Method</th>
                  <th>Bank</th>
                  <th>notes</th>
                  <th>Price</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr v-for="p in paymentList" :key="p.id">
                    <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                    <td>{{ p.method }}</td>
                    <td>
                      <span v-if="p.bank_id !== null">
                        [{{ p.account_no }}] - {{ p.bank }}
                      </span>
                      <span v-else>
                      </span>
                    </td>
                    <td>{{ p.notes }}</td>
                    <td>{{ p.price }}</td>
                    <td>
                      <button class="btn btn-sm btn-info" type="button" data-toggle="modal" data-target="#modalPaymentPurchasing" data-backdrop="static" data-keyboard="false"  @click="editPayment(p.id)">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                      </button>
                      <button type="button" class="btn btn-danger btn-sm" @click="deletePayment(p.id)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <a href='#' data-toggle="modal" data-target="#modalPaymentPurchasing" data-backdrop="static" data-keyboard="false"  style="color:blue; cursor: pointer" @click="addNewPayment">
                        Add Line
                      </a>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Total Paid</td>
                    <td>{{ getTotalPaid }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Total Purchasing</td>
                    <td>{{ this.purchasing.total }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td colspan="7"></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Amount Due</td>
                    <td>{{ getAmountDue }}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!-- <pre>{{ purchasing }}</pre> -->
        </div>
        <div class="card-footer">
         <button class="btn btn-danger btn-sm pull-left" @click="cancelPayment"><i class="fa fa-reply"></i> Back</button>
         <button class="btn btn-primary btn-sm pull-right" @click="savePayment"><i class="fa fa-save"></i> Save</button>
        </div>
      </div>
      <PurchasingPaymentModal :purchasing="purchasing" :idNew="idNew"  @backToPayment="backToPayment"/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import PurchasingPaymentModal from '@/components/purchasing/PurchasingPaymentModal.vue'
import axios from 'axios'
import { purchasingUrl, getHeader } from '../../config'

export default {
  name: 'PurchasingPayment',
  props: ['purchasing', 'amountDue'],
  components: {
    PurchasingPaymentModal
  },
  data () {
    return {
      idNew: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    ...mapState({
    //   warehouseList: state => state.warehouses.warehouseList
    }),
    paymentList: function () {
      return this.purchasing.payment.filter(d => d.id !== null)
    },
    getTotalPaid: function () {
      var sum = 0
      var array = this.purchasing.payment
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.replace(/\./g, ''))
      }
      return sum
    },
    getAmountDue: function () {
      var total = this.purchasing.total - this.getTotalPaid
      return total
    }
  },
  methods: {
    backToPayment: function (id) {
      var pay = this.purchasing.payment.find(d => d.id === id)
      if (pay.state === 'new') {
        var index = this.purchasing.payment.findIndex(d => d.id === id)
        this.purchasing.payment.splice(index, 1)
      }
    },
    addNewPayment: function () {
      this.idNew = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
      var obj = {
        id: this.idNew,
        payment_date: null,
        price: this.getAmountDue.toString(),
        method_id: null,
        method: null,
        type_id: null,
        type: null,
        bank_id: null,
        bank: null,
        account_no: null,
        notes: null,
        state: 'new'
      }
      this.purchasing.payment.push(obj)
    },
    cancelPayment: function () {
      // this.$router.replace({ path: 'purchasing', query: { purchasing: this.purchasing.id, form: 'true' }})
      this.$emit('cancelPayment', this.purchasing.id)
    },
    async savePayment () {
      await axios.put(purchasingUrl + '/' + this.purchasing.id, this.purchasing, { headers: getHeader() })
        .then(response => {
          console.log(response)
          this.$swal(
            'Success',
            response.data.data,
            'success'
          )
          this.$emit('savePayment', this.purchasing)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    deletePayment: function (id) {
      var detail = this.purchasing.payment.find(d => d.id === id)
      var index = this.purchasing.payment.findIndex(d => d.id === id)
      if (detail.state === 'new') {
        this.purchasing.payment.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(purchasingUrl + '/payment/' + detail.id, { headers: getHeader() })
              .then(response => {
                this.purchasing.payment.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    backParent: function () {
      this.$emit('backClicked', this.purchasing)
    },
    editPayment: function (id) {
      this.idNew = id
      var pay = this.purchasing.payment.find(d => d.id === id)
      pay.state = 'edit'
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
